import PropTypes from 'prop-types'
import { wrapper} from '../services/store'
import SectionHeading from 'components/SectionHeading'
import Divider from 'components/Divider'
import ContentWrapper from 'components/ContentWrapper'
import ContentItem from 'components/ContentItem'
import Tagline from 'components/Tagline'
import { Flex } from 'rebass/styled-components'
import Layout from 'components/Layout'
import CallToAction from 'components/CallToAction'
import { getPosts, getSiteMeta } from '../services/actions'

const Blog = (props) => {
  const { posts, categories, mediaCategories } = props
  //const s = useSelector(state => state)
  const blogCategory = categories.items.length
    ? categories.items.find((t) => t.slug === 'blog').id
    : undefined
  const blogItems = posts.items.length
    ? posts.items.filter((p) => p.categories.includes(blogCategory))
    : []
  const carouselCategories = mediaCategories.items.length
    ? mediaCategories.items
        .filter((c) => c.slug === 'carousel')
        .map((c) => c.id)
    : []
  const featuredImageCategory = mediaCategories.items.length
    ? mediaCategories.items
        .filter((c) => c.slug === 'cover')
        .map((c) => c.id)[0]
    : []
  return (
    <Layout>
      <ContentWrapper mb={5}>
        <Flex flexDirection='column' p={4}>
          <SectionHeading textAlign='center'>{`Captain's Blog`}</SectionHeading>
          <Tagline textAlign='center'>
            {`it's more fun if you read it aloud`}
          </Tagline>
          <Divider medium />
        </Flex>
        <Flex
          textAlign='center'
          justifyContent='center'
          width={1}
          flexWrap='wrap'
        >
          {blogItems.map((item) => (
            <ContentItem
              key={item.id}
              mediaCategories={carouselCategories}
              featuredImageCategory={featuredImageCategory}
              {...item}
            />
          ))}
        </Flex>
      </ContentWrapper>
      {/* <ContentWrapper accent $noPadding>
        <CallToAction text={`Ready, Set, Let's Go`} />
      </ContentWrapper> */}
    </Layout>
  )
}

Blog.propTypes = {
  categories: PropTypes.shape({
    items: PropTypes.array,
  }),
  posts: PropTypes.shape({
    items: PropTypes.array,
  }),
  mediaCategories: PropTypes.shape({
    items: PropTypes.array,
  }),
}

export const getServerSideProps = wrapper.getServerSideProps(
    (store) => async () => {
      const options = {
        categories: ['blog'],
      };
      await store.dispatch(getSiteMeta());
      await store.dispatch(getPosts(options));

      const state = store.getState();
      return {
        props: {
          categories: state.categories,
          posts: state.posts,
          mediaCategories: state.mediaCategories,
          tags: state.tags,
        },
      };
    }
);

export default Blog
